import http from '../../../utils/tools/http';

import {
  CENTER_FETCH_GET_MY_INTER_IOCUTION_COUNT_BEGIN,
  CENTER_FETCH_GET_MY_INTER_IOCUTION_COUNT_SUCCESS,
  CENTER_FETCH_GET_MY_INTER_IOCUTION_COUNT_FAILURE,
  CENTER_FETCH_GET_MY_INTER_IOCUTION_COUNT_DISMISS_ERROR,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function fetchGetMyInterIocutionCount(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: CENTER_FETCH_GET_MY_INTER_IOCUTION_COUNT_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest1 = http.get({
        url: "/datastore/CourseInterlocution/GetMyCourseInterlocution", params: {
          InterlocutionType: -1,
          PageSize: 5,
          PageIndex: 1,
          PageStatus: 1
        }
      });
      const doRequest2 = http.get({
        url: "/datastore/CourseInterlocution/GetMyCourseInterlocution", params: {
          InterlocutionType: 1,
          PageSize: 5,
          PageIndex: 1,
          PageStatus: 1
        }
      });
      const doRequest3 = http.get({
        url: "/datastore/CourseInterlocution/GetMyCourseInterlocution", params: {
          InterlocutionType: 0,
          PageSize: 5,
          PageIndex: 1,
          PageStatus: 1
        }
      });
      const doRequest = Promise.all([doRequest1, doRequest2, doRequest3]);
      doRequest.then(
        (res) => {
          dispatch({
            type: CENTER_FETCH_GET_MY_INTER_IOCUTION_COUNT_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: CENTER_FETCH_GET_MY_INTER_IOCUTION_COUNT_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissFetchGetMyInterIocutionCountError() {
  return {
    type: CENTER_FETCH_GET_MY_INTER_IOCUTION_COUNT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CENTER_FETCH_GET_MY_INTER_IOCUTION_COUNT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchGetMyInterIocutionCountPending: true,
        fetchGetMyInterIocutionCountError: null,
      };

    case CENTER_FETCH_GET_MY_INTER_IOCUTION_COUNT_SUCCESS:
      // The request is success
      return {
        ...state,
        fetchGetMyInterIocutionCountPending: false,
        fetchGetMyInterIocutionCountSuccess: action.data,
      };

    case CENTER_FETCH_GET_MY_INTER_IOCUTION_COUNT_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchGetMyInterIocutionCountPending: false,
        fetchGetMyInterIocutionCountError: action.data.error,
      };

    case CENTER_FETCH_GET_MY_INTER_IOCUTION_COUNT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchGetMyInterIocutionCountError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/center/redux/fetchGetMyInterIocutionCount.js